// extracted by mini-css-extract-plugin
export var hideEditor = "_m0-2";
export var infoIcon = "_m0-3";
export var label = "_m0-1";
export var labelContainer = "_m0-0";
export var readonlyText = "_m0-4";